(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bv-active-filter-notice"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bv-active-filter-notice')) return;
  customElements.define('bv-active-filter-notice', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const update = () => {
        const params = new URL(location.href).searchParams;
        const singles = /\/collections\/(frontpage|singles)\/?$/.test(location.pathname);
        this.hidden = ![...params].some(([key, value]) =>
          (key === 'bv_sale' && value === '1') ||
          (key.startsWith('filter.') && value.trim() !== '' && !(singles && key === 'filter.v.availability'))
        );
      };
      update();
      for (const event of ['popstate', 'collection:update', 'search:update']) {
        window.addEventListener(event, update, {signal: this.controller.signal});
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bv-card-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bv-card-filters')) return;
  const languageName = 'filter.p.m.custom.card_language';
  const setName = 'filter.p.m.custom.card_set';
  const artistName = 'filter.p.m.custom.card_artist';
  const rarityName = 'filter.p.m.custom.card_rarity';
  const rarityGroups = [
  [
    "secret",
    [
      "Secret Rare"
    ]
  ],
  [
    "sir",
    [
      "Special Illustration Rare",
      "Special Illustration Rare (SIR)",
      "Special Art Rare (SAR)",
      "Special Art Rare",
      "SIR",
      "SAR",
      "SIR / SAR"
    ]
  ],
  [
    "rainbow",
    [
      "Rainbow Rare",
      "Hyper Rare (HR)",
      "Rainbow Rare (HR)",
      "HR"
    ]
  ],
  [
    "shiny_ultra",
    [
      "Shiny Ultra Rare",
      "Shiny Super Rare (SSR)",
      "Shiny Ultra Rare (SSR)",
      "SSR"
    ]
  ],
  [
    "ultra",
    [
      "Ultra Rare",
      "Super Rare (SR)",
      "Super Rare",
      "SR"
    ]
  ],
  [
    "csr",
    [
      "Character Super Rare",
      "Character Super Rare (CSR)",
      "CSR"
    ]
  ],
  [
    "ir",
    [
      "Art Rare (AR)",
      "Art Rare",
      "Illustration Rare",
      "Illustration Rare (IR)",
      "AR",
      "IR",
      "AR / IR"
    ]
  ],
  [
    "chr",
    [
      "Character Rare",
      "Character Rare (CHR)",
      "CHR"
    ]
  ],
  [
    "ace",
    [
      "ACE Rare",
      "ACE SPEC Rare",
      "ACE SPEC",
      "ACE"
    ]
  ],
  [
    "shiny",
    [
      "Shiny Rare",
      "Shiny (S)",
      "Shiny Rare (S)",
      "S"
    ]
  ],
  [
    "amazing",
    [
      "Amazing Rare",
      "Amazing Rare (A)",
      "A"
    ]
  ],
  [
    "triple",
    [
      "Triple Rare",
      "Triple Rare (RRR)",
      "RRR"
    ]
  ],
  [
    "double",
    [
      "Double Rare",
      "Double Rare (RR)",
      "RR"
    ]
  ],
  [
    "holo",
    [
      "Holo Rare",
      "Rare Holo"
    ]
  ],
  [
    "rare",
    [
      "Rare",
      "Rare (R)",
      "R"
    ]
  ],
  [
    "uncommon",
    [
      "Uncommon",
      "Uncommon (U)",
      "U"
    ]
  ],
  [
    "common",
    [
      "Common",
      "Common (C)",
      "C"
    ]
  ],
  [
    "promo",
    [
      "Promo",
      "Promo (any)",
      "Black Star Promo",
      "S-P Promo",
      "SV-P Promo"
    ]
  ],
  [
    "radiant",
    [
      "Radiant Rare",
      "Radiant Rare (K)",
      "K"
    ]
  ],
  [
    "hyper",
    [
      "Hyper Rare"
    ]
  ],
  [
    "ma",
    [
      "Mega Attack Rare",
      "Mega Attack Rare (MA)",
      "MA"
    ]
  ],
  [
    "mega_hyper",
    [
      "Mega Hyper Rare",
      "Mega Ultra Rare (MUR)",
      "MUR"
    ]
  ],
  [
    "bwr",
    [
      "Black White Rare",
      "Black White Rare (BWR)",
      "BWR"
    ]
  ]
];
  const conditionName = 'filter.p.m.custom.card_condition';
  const restoredName = 'filter.p.m.custom.card_restored';
  const languages = ['English', 'Japanese', 'Simplified Chinese', 'Traditional Chinese'];
  const languageKeys = ['english', 'japanese', 'simplified', 'traditional'];
  const eras = ['Mega Evolution', 'Scarlet & Violet', 'Sword & Shield', 'Sun & Moon', 'XY', 'Black & White', 'HeartGold & SoulSilver', 'Platinum', 'Diamond & Pearl', 'EX', 'EX (PCG)', 'EX (ADV)', 'e-Card', 'Neo', 'Gym', 'Original Series', 'Promotional cards'];
  const registryCache = new Map();
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const aliases = new Map([
    [languageName, new Map([
      ['English', ['English', 'Engels', 'Englisch', 'Anglais']],
      ['Japanese', ['Japanese', 'Japans', 'Japanisch', 'Japonais']],
      ['Simplified Chinese', ['Simplified Chinese', 'Vereenvoudigd Chinees', 'Vereinfachtes Chinesisch', 'Chinois simplifié']],
      ['Traditional Chinese', ['Traditional Chinese', 'Traditioneel Chinees', 'Traditionelles Chinesisch', 'Chinois traditionnel']]
    ])],
    [restoredName, new Map([['Yes', ['Yes', 'Ja', 'Oui', 'true']], ['No', ['No', 'Nee', 'Nein', 'Non', 'false']]])]
  ]);
  const canonicalValue = (name, value) => {
    const normalized = String(value).trim().toLocaleLowerCase();
    for (const [canonical, translations] of aliases.get(name) || []) {
      if (translations.some(alias => alias.toLocaleLowerCase() === normalized)) return canonical;
    }
    return value;
  };
  const valuesFrom = (params, name) => new Set(params.getAll(name).flatMap(value => value.split(',')).map(value => canonicalValue(name, value)));
  const clearFilters = (url) => {
    [...url.searchParams.keys()].filter(key => key.startsWith('filter.') || key === 'page' || key === 'bv_sale' || key === 'bv_sale_page' || key === 'bv_generation').forEach(key => url.searchParams.delete(key));
    return url;
  };
  class CardFilters extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      if (this.dataset.singles === 'true' && new URL(location.href).searchParams.has('filter.v.availability')) {
        const clean = new URL(location.href); clean.searchParams.delete('filter.v.availability'); clean.searchParams.delete('page'); location.replace(clean); return;
      }
      this.completeCounts = this.dataset.singles === 'true' && this.dataset.completeCounts === 'true' && new URL(location.href).searchParams.get('bv_counts') !== 'legacy';
      this.saleActive = new URL(location.href).searchParams.get('bv_sale') === '1';
      this.config = JSON.parse(this.querySelector('[data-bv-config]').textContent);
      this.labels = this.config.labels;
      const appliedParams = new URL(location.href).searchParams;
      this.querySelector('[data-bv-active-warning]').hidden = !([...appliedParams].some(([name, value]) => name.startsWith('filter.') && value !== '') || appliedParams.get('bv_sale') === '1');
      this.filters = new Map(this.config.filters.map(filter => [filter.name, filter]));
      const localizedUrl = new URL(location.href);
      let changed = false;
      for (const name of aliases.keys()) {
        if (!localizedUrl.searchParams.has(name)) continue;
        const current = localizedUrl.searchParams.getAll(name).flatMap(value => value.split(','));
        const translated = [...new Set(current.flatMap(value => this.nativeValues(name, value)))];
        if (current.slice().sort().join(',') === translated.slice().sort().join(',')) continue;
        localizedUrl.searchParams.delete(name);
        translated.forEach(value => localizedUrl.searchParams.append(name, value));
        changed = true;
      }
      if (changed) { location.replace(localizedUrl); return; }
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      const listen = (target, type, callback) => target.addEventListener(type, callback, { signal: this.controller.signal });
      listen(document, 'click', (event) => {
        const reset = event.target.closest('[data-bv-reset]');
        if (reset && reset.getAttribute('aria-controls') === this.dialog.id && !reset.disabled) { event.preventDefault(); location.assign(clearFilters(new URL(location.href))); return; }
        const trigger = event.target.closest('[data-bv-open]');
        if (trigger && trigger.getAttribute('aria-controls') === this.dialog.id) {
          event.preventDefault();
          this.open(trigger);
        }
        const shortcut = event.target.closest('[data-bv-language]');
        if (shortcut && !shortcut.disabled) {
          const url = new URL(location.href);
          url.searchParams.delete('page');
          url.searchParams.delete(setName);
          this.setNativeValues(url, languageName, shortcut.dataset.bvLanguage);
          location.assign(url);
        }
      });
      listen(this.querySelector('[data-bv-close]'), 'click', () => this.dialog.close());
      listen(this.dialog, 'click', event => { if (event.target === this.dialog && event.clientX > this.dialog.getBoundingClientRect().right) this.dialog.close(); });
      listen(this.dialog, 'close', () => this.trigger?.focus());
      listen(this.querySelector('[data-bv-clear]'), 'click', event => {
        event.preventDefault();
        this.form.querySelectorAll('input[type=checkbox]').forEach(input => { input.checked = false; input.indeterminate = false; });
        this.form.querySelectorAll('input[type=number]').forEach(input => { input.value = ''; input.setCustomValidity(''); });
        location.assign(clearFilters(new URL(location.href)));
      });
      listen(this.form, 'change', event => {
        const input = event.target;
        if (input.matches('[data-bv-era-all]')) {
          input.closest('details').querySelectorAll('input[data-bv-set]').forEach(choice => { if (!choice.disabled && !choice.parentElement.hidden) choice.checked = input.checked; });
        }
        if (input.matches('[data-bv-set], [data-bv-era-all]') && input.checked) {
          const group = input.closest('[data-bv-language-group]');
          const language = group?.querySelector('input[data-bv-lang]');
          if (language && !language.disabled) language.checked = true;
        }
        if (input.matches('[data-bv-lang]') && !input.checked) {
          input.closest('[data-bv-language-group]').querySelectorAll('input[data-bv-set],input[data-bv-era-all]').forEach(choice => { choice.checked = false; });
        }
        if (this.countsReady && !this.countsPending) this.updateCountDisplay();
        this.sync();
      });
      listen(this.form, 'input', event => {
        const input = event.target;
        if (input.matches('[data-bv-min], [data-bv-max], [data-bv-min-slider], [data-bv-max-slider]')) this.updatePrice(input);
      });
      listen(this.form, 'submit', event => {
        event.preventDefault();
        if (!this.form.reportValidity()) return;
        const url = clearFilters(new URL(location.href));
        const fields = new Map();
        this.form.querySelectorAll('input[name]:not(:disabled)').forEach(input => {
          if (input.type === 'checkbox' && !input.checked) return;
          if (!input.value) return;
          if (!fields.has(input.name)) fields.set(input.name, new Set());
          (input.name === rarityName ? input.value.split(',') : [input.value]).forEach(value => fields.get(input.name).add(value));
        });
        fields.forEach((values, name) => [...new Set([...values].flatMap(value => this.nativeValues(name, value)))].forEach(value => url.searchParams.append(name, value)));
        location.assign(url);
      });
      const applied = valuesFrom(new URL(location.href).searchParams, languageName);
      document.querySelectorAll('[data-bv-language]').forEach(button => button.setAttribute('aria-pressed', String(applied.has(button.dataset.bvLanguage))));
      document.querySelectorAll('[data-bv-reset]').forEach(button => {
        if (button.getAttribute('aria-controls') === this.dialog.id) button.disabled = ![...new URL(location.href).searchParams.keys()].some(key => key.startsWith('filter.') || key === 'bv_sale');
      });
      this.buildStatic();
      if (new URL(location.href).searchParams.has('bv_generation')) this.applyGeneration();
    }
    async applyGeneration() {
      const status = this.querySelector('[data-bv-generation-status]');
      status.hidden = false;
      status.textContent = this.labels.generation_loading;
      try {
        const url = new URL(location.href);
        const era = url.searchParams.get('bv_generation');
        const registry = await this.loadRegistry();
        if (!this.isConnected) return;
        const ids = registry.sets.filter(set => set.era === era).map(set => set.id);
        if (!ids.length || !this.filters.has(setName)) throw new Error('Generation unavailable');
        url.searchParams.delete('bv_generation');
        url.searchParams.delete('page');
        url.searchParams.delete(setName);
        [...new Set(ids)].forEach(id => url.searchParams.append(setName, id));
        location.replace(url);
      } catch (error) {
        if (this.isConnected) status.textContent = this.labels.generation_error;
      }
    }
    nativeValues(name, value) {
      if (!aliases.has(name)) return [value];
      const canonical = canonicalValue(name, value);
      const matches = this.filters.get(name)?.values.filter(option => canonicalValue(name, option.value) === canonical).map(option => option.value) || [];
      return matches.length ? [...new Set(matches)] : [value];
    }
    setNativeValues(url, name, value) {
      url.searchParams.delete(name);
      this.nativeValues(name, value).forEach(native => url.searchParams.append(name, native));
    }
    normalizeCounts(data) {
      const counts = new Map();
      data.languages.forEach(value => {
        const id = canonicalValue(languageName, value.id);
        counts.set(id, (counts.get(id) || 0) + value.count);
      });
      return { ...data, languages: [...counts].map(([id, count]) => ({ id, count })) };
    }
    disconnectedCallback() { this.controller?.abort(); }
    choice(name, value, label, enabled, count) {
      const wrapper = element('label', undefined, 'bv-filter-choice');
      const input = element('input'); input.type = 'checkbox'; input.name = name; input.value = value; input.disabled = !enabled; input.dataset.label = label;
      wrapper.append(input, element('span', label));
      if (count !== undefined) wrapper.append(element('small', '[' + count + ']'));
      return wrapper;
    }
    buildStatic() {
      this.querySelector('[data-bv-condition]').hidden = this.dataset.sealed === 'true';
      this.querySelector('[data-bv-artist]').hidden = this.dataset.sealed === 'true';
      const conditionOptions = this.querySelector('[data-bv-condition-options]');
      conditionOptions.replaceChildren();
      if (this.dataset.sealed !== 'true') ['Mint', 'Near-Mint', 'Excellent', 'Good', 'Light Played', 'Played', 'Poor'].forEach(value => conditionOptions.append(this.choice(conditionName, value, value, this.filters.has(conditionName))));
      if (!this.filters.has(conditionName)) conditionOptions.append(element('p', this.labels.not_ready, 'bv-filter-note'));
      this.querySelector('[data-bv-restored]').hidden = this.dataset.sealed === 'true';
      const restored = this.querySelector('[data-bv-restored-options]');
      restored.replaceChildren();
      ['Yes', 'No'].forEach(value => restored.append(this.choice(restoredName, value, this.labels[value.toLowerCase()], this.filters.has(restoredName))));
      if (!this.filters.has(restoredName)) restored.append(element('p', this.labels.not_ready, 'bv-filter-note'));
      const rarity = this.filters.get(rarityName);
      const rarityOptions = this.querySelector('[data-bv-rarity-options]');
      rarityOptions.replaceChildren();
      this.querySelector('[data-bv-rarity]').hidden = this.dataset.sealed === 'true' || !rarity;
      const normalizeRarity = value => value.trim().toLocaleLowerCase();
      const remainingRarities = new Set(rarity?.values || []);
      rarityGroups.forEach(([key, aliases]) => {
        const normalized = new Set(aliases.map(normalizeRarity));
        const matches = [...remainingRarities].filter(value => normalized.has(normalizeRarity(value.value)) || (key === 'promo' && /promo/i.test(value.value)));
        matches.forEach(value => remainingRarities.delete(value));
        const count = matches.reduce((total, value) => total + value.count, 0);
        const values = [...new Set(matches.map(value => value.value))];
        const active = matches.some(value => value.active) || values.some(value => valuesFrom(new URL(location.href).searchParams, rarityName).has(value));
        rarityOptions.append(this.choice(rarityName, values.join(','), this.config.rarityLabels[key], count > 0 || active, count));
      });
      [...remainingRarities].filter(value => !/^no rarity$/i.test(value.value) && (value.count > 0 || value.active)).forEach(value => rarityOptions.append(this.choice(rarityName, value.value, value.label, true, value.count)));
      const availability = this.querySelector('[data-bv-availability]'); availability.replaceChildren();
      (this.dataset.singles === 'true' ? [] : this.filters.get('filter.v.availability')?.values || []).forEach(value => availability.append(this.choice('filter.v.availability', value.value, value.label, true, value.count)));
      const price = this.config.filters.find(filter => filter.type === 'price_range');
      this.priceMax = price ? Math.max(0, price.rangeMax / 100) : 0;
      this.querySelectorAll('[data-bv-price] input').forEach(input => { input.disabled = !price; input.max = String(this.priceMax); });
      if (!price) this.querySelector('[data-bv-price]').append(element('p', this.labels.currency, 'bv-filter-note'));
    }
    async loadRegistry() {
      const marker = document.querySelector('[data-bv-registry]');
      if (!marker) throw new Error('Missing registry section');
      const sectionId = marker.dataset.sectionId;
      const cacheKey = location.pathname + ':' + sectionId;
      if (registryCache.has(cacheKey)) return registryCache.get(cacheKey);
      const load = async () => {
        const start = new URL(location.href);
        start.search = '';
        if (new URL(location.href).searchParams.get('view') === 'bv-cards') start.searchParams.set('view','bv-cards');
        start.searchParams.set('section_id', sectionId);
        const visit = async url => {
          const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal });
          if (!response.ok) throw new Error('Registry response failed');
          return new DOMParser().parseFromString(await response.text(), 'text/html');
        };
        const first = [...marker.querySelectorAll('[data-bv-registry-sets],[data-bv-registry-artists]')].length === 2 && ![...new URL(location.href).searchParams.keys()].some(key => key.startsWith('page')) ? marker : await visit(start);
        const result = {};
        for (const kind of ['sets', 'artists']) {
          let doc = first;
          const records = new Map();
          const visited = new Set();
          while (true) {
            const script = doc.querySelector('[data-bv-registry-' + kind + ']');
            if (!script) throw new Error('Registry data missing');
            const data = JSON.parse(script.textContent);
            data.items.forEach(item => records.set(item.id, item));
            if (!data.next) break;
            const next = new URL(data.next, location.origin);
            next.searchParams.set('section_id', sectionId);
            if (next.origin !== location.origin || visited.has(next.href)) throw new Error('Registry pagination failed');
            visited.add(next.href);
            doc = await visit(next);
          }
          result[kind] = [...records.values()];
        }
        return result;
      };
      const promise = load().catch(error => { registryCache.delete(cacheKey); throw error; });
      registryCache.set(cacheKey, promise);
      return promise;
    }
    getCountCache() {
      if (this.countCache) return this.countCache;
      this.countCacheKey = 'bv-counts-v4:' + this.dataset.countCacheKey;
      let entries = [];
      try { entries = JSON.parse(sessionStorage.getItem(this.countCacheKey) || '[]'); } catch (error) {}
      this.countCache = new Map(Array.isArray(entries) ? entries.filter(entry => Array.isArray(entry) && entry[1]?.at > Date.now() - 30000) : []);
      return this.countCache;
    }
    saveCountCache() {
      if (!this.countCache) return;
      const entries = [...this.countCache].filter(([,entry]) => entry.at > Date.now() - 30000).slice(-120);
      try { sessionStorage.setItem(this.countCacheKey, JSON.stringify(entries)); } catch (error) {}
    }
    async loadScopedCounts() {
      if (this.counts && Date.now() - this.countedAt < 30000) return this.counts;
      const manifest = JSON.parse(this.querySelector('[data-bv-count-scopes]').textContent);
      const started = performance.now();
      this.labels.counts_note = this.labels.counts_scope_note;
      this.labels.counts_unavailable = this.labels.counts_scope_unavailable;
      const unknown = () => ({ values: new Map(), complete: false });
      this.counts = new Map(languages.map(language => [language, { values: new Map(), complete: true }]));
      this.artistCounts = { values: new Map(), complete: true };
      const pool = async (jobs, task) => {
        const results = new Array(jobs.length);
        let cursor = 0;
        await Promise.all(Array.from({ length: Math.min(4, jobs.length) }, async () => {
          while (cursor < jobs.length) {
            const index = cursor++;
            results[index] = await task(jobs[index], index);
          }
        }));
        return results;
      };
      const request = async (scope, mode, language) => {
        try {
          const url = new URL(location.href);
          url.pathname = url.pathname.replace(/\/collections\/[^/]+\/?$/, '/collections/' + scope.handle);
          url.searchParams.delete('page');
          if (mode === 'sets') {
            url.searchParams.delete(languageName);
            url.searchParams.delete(setName);
          } else url.searchParams.delete(artistName);
          if (language) this.setNativeValues(url, languageName, language);
          url.searchParams.delete('sort_by');
          if (this.dataset.singles === 'true') url.searchParams.set('filter.v.availability', '1');
          url.searchParams.set('section_id', 'bv-card-filter-counts');
          url.searchParams.sort();
          const cache = this.getCountCache();
          const cached = cache.get(url.href);
          if (cached?.at > Date.now() - 30000) return cached.data;
          const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(10000)]) });
          if (!response.ok) throw new Error('Counts unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(doc.querySelector('[data-bv-counts]').textContent);
          if (!Number.isInteger(data.total) || !Number.isInteger(data.matched) || !Array.isArray(data.values) || !Array.isArray(data.artists) || !Array.isArray(data.languages)) throw new Error('Invalid counts');
          const normalized = this.normalizeCounts(data);
          cache.set(url.href, { at: Date.now(), data: normalized });
          return normalized;
        } catch (error) { return null; }
      };
      const source = await request({ handle: manifest.sourceHandle }, 'sets');
      const fullyCounted = (data, key, support) => data && (data.matched === 0 || (data[support] && data[key].every(value => Number.isInteger(value.count) && value.count >= 0) && data[key].reduce((sum, value) => sum + value.count, 0) === data.matched));
      const sourceLanguages = source?.languages.filter(value => value.count > 0) || [];
      if (fullyCounted(source, 'values', 'supported') && fullyCounted(source, 'languages', 'languageSupported') && sourceLanguages.every(value => languages.includes(value.id))) {
        const directLanguages = await pool(sourceLanguages, async language => ({
          language: language.id,
          expected: language.count,
          data: sourceLanguages.length === 1 ? source : await request({ handle: manifest.sourceHandle }, 'sets', language.id)
        }));
        const selected = new URL(location.href).searchParams;
        const directArtists = [languageName, setName, artistName].some(name => selected.has(name)) ? await request({ handle: manifest.sourceHandle }, 'artists') : source;
        if (directLanguages.every(({ data, expected }) => fullyCounted(data, 'values', 'supported') && data.matched === expected) && fullyCounted(directArtists, 'artists', 'artistSupported')) {
          directLanguages.forEach(({ language, data }) => {
            this.counts.get(language).values = new Map(data.values.map(value => [value.id, value.count]));
          });
          this.artistCounts.values = new Map(directArtists.artists.map(value => [value.id, value.count]));
          this.countedAt = Date.now();
          this.saveCountCache();
          this.dataset.bvCountLoadMs = String(Math.round(performance.now() - started));
          return this.counts;
        }
      }
      const base = await pool(manifest.scopes, scope => request(scope, 'sets'));
      const coverage = source && base.every(Boolean) && base.reduce((sum, data) => sum + data.total, 0) === source.total && base.reduce((sum, data) => sum + data.matched, 0) === source.matched;
      if (!coverage) {
        this.counts = new Map(languages.map(language => [language, unknown()]));
        this.artistCounts = unknown();
        this.saveCountCache();
        this.dataset.bvCountLoadMs = String(Math.round(performance.now() - started));
        return this.counts;
      }
      const merge = (target, values) => values.forEach(value => target.values.set(value.id, (target.values.get(value.id) || 0) + value.count));
      const complete = (data, key, support) => data.matched === 0 || (data[support] && (data[key].length < 100 || data[key].reduce((sum, value) => sum + value.count, 0) === data.matched));
      const jobs = [];
      base.forEach((data, index) => {
        const scope = manifest.scopes[index];
        const possible = scope.catalogue === 'Japanese' ? ['Japanese', 'Traditional Chinese'] : [scope.catalogue];
        const positive = data.languages.filter(value => value.count > 0);
        if (data.matched > 0 && (!data.languageSupported || positive.reduce((sum, value) => sum + value.count, 0) !== data.matched || positive.some(value => !possible.includes(value.id)))) {
          possible.forEach(language => { this.counts.get(language).complete = false; });
          return;
        }
        positive.forEach(value => {
          if (positive.length > 1) jobs.push({ scope, language: value.id });
          else {
            const target = this.counts.get(value.id);
            target.complete &&= complete(data, 'values', 'supported');
            merge(target, data.values);
          }
        });
      });
      await pool(jobs, async ({ scope, language }) => {
        const data = await request(scope, 'sets', language);
        const target = this.counts.get(language);
        if (!data) target.complete = false;
        else {
          target.complete &&= complete(data, 'values', 'supported');
          merge(target, data.values);
        }
      });
      const params = new URL(location.href).searchParams;
      const separateArtists = [languageName, setName, artistName].some(name => params.has(name));
      const artistSource = separateArtists ? await request({ handle: manifest.sourceHandle }, 'artists') : source;
      const artistData = artistSource && complete(artistSource, 'artists', 'artistSupported') ? [artistSource] : separateArtists ? await pool(manifest.scopes, scope => request(scope, 'artists')) : base;
      if (!artistSource || !artistData.every(Boolean) || artistData.reduce((sum, data) => sum + (data?.matched || 0), 0) !== artistSource.matched) this.artistCounts.complete = false;
      artistData.forEach(data => {
        if (!data || !complete(data, 'artists', 'artistSupported')) this.artistCounts.complete = false;
        else merge(this.artistCounts, data.artists);
      });
      this.counts.forEach(scope => { if (!scope.complete) scope.values.clear(); });
      this.countedAt = Date.now();
      this.saveCountCache();
      this.dataset.bvCountLoadMs = String(Math.round(performance.now() - started));
      return this.counts;
    }
    async loadCompleteCounts() {
      const started = performance.now();
      const base = new URL(location.href);
      for (const key of [...base.searchParams.keys()]) {
        if (key.startsWith('filter.') || ['page', 'view', 'sort_by', 'bv_sale', 'bv_sale_page', 'bv_generation', 'section_id'].includes(key)) base.searchParams.delete(key);
      }
      base.searchParams.set('section_id', 'bv-card-count-index');
      base.searchParams.set('sort_by', 'created-ascending');
      const rows = [];
      let expected;
      let pages = 1;
      let bytes = 0;
      for (let page = 1; page <= pages; page++) {
        base.searchParams.set('page', String(page));
        const response = await fetch(base, { credentials: 'same-origin', signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(15000)]) });
        if (!response.ok) throw new Error('Card index unavailable');
        const html = await response.text();
        bytes += new Blob([html]).size;
        const document = new DOMParser().parseFromString(html, 'text/html');
        const data = JSON.parse(document.querySelector('[data-bv-card-index]')?.textContent || 'null');
        if (!data || data.version !== 1 || String(data.theme) !== this.dataset.countCacheKey.split(':')[0] || data.page !== page || !Array.isArray(data.items)) throw new Error('Invalid card index');
        if (page === 1) { expected = data.total; pages = Math.max(1, data.pages); }
        if (data.total !== expected || Math.max(1, data.pages) !== pages || expected > 25000 || pages > 100) throw new Error('Card index changed or exceeded supported size');
        rows.push(...data.items);
      }
      if (rows.length !== expected || new Set(rows.map(row => row.id)).size !== expected) throw new Error('Incomplete card index');
      this.indexRows = rows;
      this.dataset.bvCountRows = String(rows.length);
      this.dataset.bvCountBytes = String(bytes);
      this.dataset.bvCountLoadMs = String(Math.round(performance.now() - started));
      this.computeCompleteCounts();
      return this.counts;
    }
    computeCompleteCounts() {
      const started = performance.now();
      const params = new URL(location.href).searchParams;
      const fields = new Map([[languageName, 'language'], [setName, 'set'], [artistName, 'artist'], [rarityName, 'rarity'], [conditionName, 'condition'], [restoredName, 'restored']]);
      const selected = new Map([...fields.keys()].map(name => [name, valuesFrom(params, name)]));
      const minimum = params.has('filter.v.price.gte') ? Number(params.get('filter.v.price.gte')) * 100 : -Infinity;
      const maximum = params.has('filter.v.price.lte') ? Number(params.get('filter.v.price.lte')) * 100 : Infinity;
      // Unknown filters must never silently produce misleading zero counts.
      const supported = new Set([...fields.keys(), 'filter.v.price.gte', 'filter.v.price.lte', 'filter.v.availability']);
      if ([...params.keys()].some(key => key.startsWith('filter.') && !supported.has(key))) throw new Error('Unsupported count filter');
      const matches = (row, ignored) => [...selected].every(([name, values]) => !values.size || ignored.has(name) || values.has(canonicalValue(name, String(row[fields.get(name)] ?? ''))));
      const setIgnored = new Set([languageName, setName]);
      const artistIgnored = new Set([artistName]);
      this.counts = new Map(languages.map(language => [language, { values: new Map(), complete: true }]));
      this.artistCounts = { values: new Map(), complete: true };
      const add = (map, key) => map.set(key, (map.get(key) || 0) + 1);
      let available = 0;
      for (const row of this.indexRows) {
        if (!row.available) continue;
        available++;
        if (!row.variants.some(([price]) => price >= minimum && price <= maximum)) continue;
        if (params.get('bv_sale') === '1' && !row.variants.some(([price, compare]) => compare > price)) continue;
        const language = canonicalValue(languageName, String(row.language ?? ''));
        if (row.set && this.counts.has(language) && matches(row, setIgnored)) add(this.counts.get(language).values, row.set);
        if (row.artist && matches(row, artistIgnored)) add(this.artistCounts.values, row.artist);
      }
      this.dataset.bvCountAvailable = String(available);
      this.dataset.bvCountComputeMs = String(Math.round((performance.now() - started) * 100) / 100);
      this.dataset.bvCountState = 'complete';
    }
    async loadCounts() {
      if (this.completeCounts) return this.loadCompleteCounts();
      if (this.querySelector('[data-bv-count-scopes]')) return this.loadScopedCounts();
      if (this.counts) return this.counts;
      const entries = await Promise.all(languages.map(async language => {
        try {
          const url = new URL(location.href);
          url.searchParams.delete('page');
          url.searchParams.delete(setName);
          this.setNativeValues(url, languageName, language);
          if (this.dataset.singles === 'true') url.searchParams.set('filter.v.availability', '1');
          url.searchParams.set('section_id', 'bv-card-filter-counts');
          const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal });
          if (!response.ok) throw new Error('Counts unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(doc.querySelector('[data-bv-counts]').textContent);
          const values = new Map(data.values.map(value => [value.id, value.count]));
          const complete = data.supported && data.values.length < 100;
          return [language, { values, complete }];
        } catch (error) { return [language, { values: new Map(), complete: false }]; }
      }));
      this.counts = new Map(entries);
      try {
        const url = new URL(location.href);
        url.searchParams.delete('page');
        url.searchParams.delete(artistName);
        if (this.dataset.singles === 'true') url.searchParams.set('filter.v.availability', '1');
        url.searchParams.set('section_id', 'bv-card-filter-counts');
        const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(10000)]) });
        if (!response.ok) throw new Error('Counts unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(doc.querySelector('[data-bv-counts]').textContent);
        this.artistCounts = {
          values: new Map(data.artists.map(value => [value.id, value.count])),
          complete: data.artistSupported && (data.artists.length < 100 || data.artists.reduce((sum, value) => sum + value.count, 0) === data.matched)
        };
      } catch (error) { this.artistCounts = { values: new Map(), complete: false }; }
      return this.counts;
    }
    async open(trigger) {
      this.trigger = trigger;
      this.dialog.showModal();
      const openedAt = performance.now();
      const opening = this.opening = (this.opening || 0) + 1;
      const status = this.querySelector('[data-bv-status]');
      const submit = this.form.querySelector('[type=submit]');
      status.textContent = this.built ? '' : this.labels.loading;
      submit.disabled = !this.built;
      try {
        if (!this.built) {
          const registry = await this.loadRegistry();
          if (!this.isConnected || opening !== this.opening) return;
          this.buildTree(registry.sets);
          this.buildArtists(registry.artists);
          this.built = true;
        }
        this.restore();
        status.textContent = '';
        submit.disabled = false;
        this.dataset.bvDrawerReadyMs = String(Math.round(performance.now() - openedAt));
        if (this.saleActive && !this.completeCounts) return;
        if (this.countsReady && !this.countsPending) this.updateCountDisplay();
        if (!this.countJob) {
          this.countsPending = true;
          this.countJob = this.loadCounts().catch(() => {
            this.dataset.bvCountState = 'unavailable';
            this.counts = new Map(languages.map(language => [language, { values: new Map(), complete: false }]));
            this.artistCounts = { values: new Map(), complete: false };
          }).finally(() => {
            this.countsPending = false;
            this.countsReady = true;
            this.countJob = null;
          });
        }
        await this.countJob;
        if (!this.isConnected || opening !== this.opening) return;
        this.updateCountDisplay();
      } catch (error) {
        status.textContent = this.labels.load_error;
      }
    }
    updateCountDisplay() {
      if (this.completeCounts && this.indexRows && this.dataset.bvCountState === 'complete') this.computeCompleteCounts();
      const decorate = (input, count, search = '') => {
        const row = input.parentElement;
        let badge = row.querySelector('small');
        if (count === undefined) badge?.remove();
        else {
          if (!badge) { badge = element('small'); row.append(badge); }
          badge.textContent = '[' + count + ']';
        }
        const preserve = input.checked || row.contains(document.activeElement);
        row.hidden = (count === 0 && !preserve) || (search !== '' && !input.dataset.label.toLocaleLowerCase().includes(search));
      };
      this.querySelectorAll('[data-bv-language-group]').forEach(group => {
        const scope = this.counts?.get(group.dataset.bvLanguageGroup);
        group.querySelectorAll('.bv-filter-era').forEach(branch => {
          let total = 0;
          let known = true;
          const inputs = [...branch.querySelectorAll('[data-bv-set]')];
          inputs.forEach(input => {
            const count = scope?.values.get(input.value) ?? (scope?.complete ? 0 : undefined);
            if (count === undefined) known = false;
            else total += count;
            decorate(input, count);
          });
          branch.querySelector('summary').textContent = branch.dataset.bvEra + (known ? ' [' + total + ']' : '');
          branch.hidden = inputs.every(input => input.parentElement.hidden);
        });
        const empty = group.querySelector('[data-bv-empty]');
        if (empty) empty.hidden = [...group.querySelectorAll('.bv-filter-era')].some(branch => !branch.hidden);
      });
      const search = this.querySelector('[data-bv-artist-search]').value.toLocaleLowerCase();
      this.querySelectorAll('[data-bv-artist-options] input').forEach(input => {
        decorate(input, this.artistCounts?.complete ? this.artistCounts.values.get(input.value) || 0 : undefined, search);
      });
      this.sync();
    }
    buildTree(sets) {
      const tree = this.querySelector('[data-bv-tree]'); tree.replaceChildren();
      languages.forEach((language, index) => {
        const group = element('details', undefined, 'bv-filter-group bv-filter-language'); group.dataset.bvLanguageGroup = language;
        const summary = element('summary');
        const languageTitle = element('span', this.labels[languageKeys[index]]);
        summary.append(languageTitle);
        group.append(summary);
        const options = element('div', undefined, 'bv-filter-options');
        const langChoice = this.choice(languageName, language, this.labels[languageKeys[index]], this.filters.has(languageName));
        langChoice.classList.add('bv-language-choice');
        languageTitle.classList.add('bv-language-title');
        langChoice.querySelector('span').classList.add('visually-hidden');
        langChoice.addEventListener('click', event => event.stopPropagation());
        langChoice.addEventListener('keydown', event => event.stopPropagation());
        langChoice.querySelector('input').dataset.bvLang = '';
        langChoice.querySelector('input').dataset.label = this.labels[languageKeys[index]];
        summary.prepend(langChoice);
        if (language === 'Traditional Chinese') options.append(element('p', this.labels.traditional_note, 'bv-filter-note'));
        const catalogue = language === 'Traditional Chinese' ? 'Japanese' : language;
        const scope = this.counts?.get(language);
        const countFor = set => scope?.values.get(set.id) ?? (scope?.complete ? 0 : undefined);
        const params = new URL(location.href).searchParams;
        const activeSets = valuesFrom(params, setName);
        const activeLanguages = valuesFrom(params, languageName);
        const isActive = set => activeSets.has(set.id) && (!activeLanguages.size || activeLanguages.has(language));
        const matching = sets.filter(set => set.catalogue === catalogue);
        const byEra = new Map();
        matching.forEach(set => { if (!byEra.has(set.era)) byEra.set(set.era, []); byEra.get(set.era).push(set); });
        const order = [...byEra.keys()].sort((a,b) => {
          const ai = eras.indexOf(a), bi = eras.indexOf(b);
          return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi) || a.localeCompare(b);
        });
        order.forEach(era => {
          const branch = element('details', undefined, 'bv-filter-group bv-filter-era');
          branch.dataset.bvEra = era;
          const eraSets = byEra.get(era);
          const total = scope?.complete ? eraSets.reduce((sum, set) => sum + countFor(set), 0) : undefined;
          branch.append(element('summary', era + (total === undefined ? '' : ' [' + total + ']')));
          const children = element('div', undefined, 'bv-filter-options');
          const all = this.choice('', '', this.labels.all_era, this.filters.has(setName) && this.filters.has(languageName));
          all.querySelector('input').removeAttribute('name'); all.querySelector('input').dataset.bvEraAll = '';
          children.append(all);
          byEra.get(era).sort((a,b) => String(b.releaseDate || '').localeCompare(String(a.releaseDate || '')) || a.name.localeCompare(b.name, undefined, {numeric:true})).forEach(set => {
            const row = this.choice(setName, set.id, set.name + (set.code ? ' · ' + set.code : ''), this.filters.has(setName) && this.filters.has(languageName), countFor(set));
            row.dataset.bvSearch = (set.name + ' ' + (set.code || '') + ' ' + era).toLocaleLowerCase();
            row.querySelector('input').dataset.bvSet = '';
            children.append(row);
          });
          branch.append(children); options.append(branch);
        });
        const empty = element('p', this.labels.empty, 'bv-filter-note bv-filter-empty');
        empty.dataset.bvEmpty = ''; empty.hidden = matching.length > 0; options.append(empty);
        if (!this.filters.has(setName) || !this.filters.has(languageName)) options.append(element('p', this.labels.not_ready, 'bv-filter-note'));
        group.append(options); tree.append(group);
      });
    }
    buildArtists(artists) {
      const target = this.querySelector('[data-bv-artist-options]'); target.replaceChildren();
      if (this.dataset.sealed === 'true') return;
      artists.sort((a,b) => a.name.localeCompare(b.name)).forEach(artist => {
        target.append(this.choice(artistName, artist.id, artist.name, this.filters.has(artistName)));
      });
      if (artists.length && !target.children.length) target.append(element('p', this.labels.empty, 'bv-filter-note'));
      if (!artists.length) target.append(element('p', this.labels.empty, 'bv-filter-note'));
      if (!this.filters.has(artistName)) target.append(element('p', this.labels.not_ready, 'bv-filter-note'));
      const search = this.querySelector('[data-bv-artist-search]'); search.value = '';
      search.oninput = () => {
        if (this.countsReady && !this.countsPending) this.updateCountDisplay();
        else target.querySelectorAll('label').forEach(row => { row.hidden = !row.textContent.toLocaleLowerCase().includes(search.value.toLocaleLowerCase()); });
      };
    }
    restore() {
      const params = new URL(location.href).searchParams;
      const selectedLanguages = valuesFrom(params, languageName);
      this.form.querySelectorAll('input[type=checkbox][name]').forEach(input => {
        const group = input.closest('[data-bv-language-group]');
        input.checked = (input.name === rarityName ? input.value.split(',').some(value => valuesFrom(params, input.name).has(value)) : valuesFrom(params, input.name).has(input.value)) && (!input.hasAttribute('data-bv-set') || !selectedLanguages.size || selectedLanguages.has(group?.dataset.bvLanguageGroup));
      });
      this.querySelector('[data-bv-min]').value = params.get('filter.v.price.gte') || '';
      this.querySelector('[data-bv-max]').value = params.get('filter.v.price.lte') || '';
      this.updatePrice(); this.sync();
    }
    updatePrice(changed) {
      const min = this.querySelector('[data-bv-min]'), max = this.querySelector('[data-bv-max]');
      const low = this.querySelector('[data-bv-min-slider]'), high = this.querySelector('[data-bv-max-slider]');
      if (changed === low) { min.value = low.value; if (Number(low.value) > Number(max.value || this.priceMax)) max.value = low.value; }
      if (changed === high) { max.value = high.value; if (Number(high.value) < Number(min.value || 0)) min.value = high.value; }
      low.value = min.value || '0'; high.value = max.value || String(this.priceMax);
      const invalid = min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value);
      min.setCustomValidity(invalid ? this.labels.minimum_order || 'Minimum price must not exceed maximum price.' : '');
      this.sync();
    }
    sync() {
      this.querySelectorAll('.bv-filter-era').forEach(branch => {
        const choices = [...branch.querySelectorAll('[data-bv-set]')].filter(input => !input.parentElement.hidden);
        const all = branch.querySelector('[data-bv-era-all]');
        all.checked = choices.length > 0 && choices.every(input => input.checked);
        all.indeterminate = !all.checked && choices.some(input => input.checked);
      });
      const target = this.querySelector('[data-bv-selected]');
      const focusedLabel = target.contains(document.activeElement) ? document.activeElement.getAttribute('aria-label') : null;
      target.replaceChildren();
      const selected = new Map();
      this.form.querySelectorAll('input[type=checkbox][name]:checked').forEach(input => {
        const key = input.name + ':' + input.value;
        if (!selected.has(key)) selected.set(key, []);
        selected.get(key).push(input);
      });
      selected.forEach(inputs => {
        const chip = element('button', inputs[0].dataset.label + ' ×'); chip.type = 'button';
        chip.setAttribute('aria-label', this.labels.remove + ' ' + inputs[0].dataset.label);
        chip.onclick = () => { inputs.forEach(input => { input.checked = false; input.dispatchEvent(new Event('change', {bubbles:true})); }); this.sync(); };
        target.append(chip);
        if (focusedLabel && chip.getAttribute('aria-label') === focusedLabel) chip.focus({ preventScroll: true });
      });
    }
  }
  customElements.define('bv-card-filters', CardFilters);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bv-card-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.bvCardDiscoveryReady) return;
  window.bvCardDiscoveryReady = true;
  let busy = false;
  const restore = () => {
    busy = false;
    document.querySelectorAll('[data-bv-random]').forEach(button => {
      button.removeAttribute('aria-busy');
      if (button.dataset.originalLabel) button.querySelector('span').textContent = button.dataset.originalLabel;
    });
  };
  addEventListener('pageshow', restore);
  const randomIndex = length => {
    const values = new Uint32Array(1);
    const ceiling = Math.floor(4294967296 / length) * length;
    do { crypto.getRandomValues(values); } while (values[0] >= ceiling);
    return values[0] % length;
  };
  const read = async url => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error('Unavailable');
    return response.json();
  };
  document.addEventListener('click', async event => {
    const back = event.target.closest('[data-bv-back]');
    if (back && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      if (history.length > 1 && document.referrer) { event.preventDefault(); history.back(); }
      return;
    }
    const button = event.target.closest('[data-bv-random]');
    if (!button || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const group = button.closest('[data-bv-card-navigation]');
    const status = group.querySelector('[role=status]');
    status.hidden = true;
    button.dataset.originalLabel ||= button.querySelector('span').textContent;
    button.querySelector('span').textContent = group.dataset.loading;
    button.setAttribute('aria-busy', 'true');
    try {
      const base = new URL(group.dataset.singlesUrl, location.origin);
      base.searchParams.set('view', 'bv-random');
      base.searchParams.set('filter.v.availability', '1');
      base.searchParams.set('sort_by', 'created-ascending');
      const first = await read(base);
      if (!Array.isArray(first.products) || !Number.isInteger(first.pages) || first.total > 25000) throw new Error('Invalid catalogue');
      const entries = [...first.products];
      for (let page = 2; page <= first.pages; page += 4) {
        const numbers = Array.from({length:Math.min(4,first.pages-page+1)}, (_, i) => page+i);
        const chunks = await Promise.all(numbers.map(number => { const url = new URL(base); url.searchParams.set('page',String(number)); return read(url); }));
        for (const chunk of chunks) { if (!Array.isArray(chunk.products)) throw new Error('Invalid page'); entries.push(...chunk.products); }
      }
      let candidates = [...new Map(entries.filter(item => item.eligible && item.url).map(item => [item.id,item])).values()];
      if (candidates.length > 1) candidates = candidates.filter(item => item.id !== group.dataset.currentCard);
      while (candidates.length) {
        const [candidate] = candidates.splice(randomIndex(candidates.length),1);
        if (candidate.id === group.dataset.currentCard) { status.textContent = group.dataset.only; status.hidden = false; return; }
        const target = new URL(candidate.url, location.origin);
        if (target.origin !== location.origin || !target.pathname.includes('/products/')) throw new Error('Invalid product');
        const check = new URL(target); check.pathname += '.js'; check.search = '';
        const product = await read(check);
        if (product.type !== 'Singles' || !product.variants?.some(variant => variant.available)) continue;
        location.assign(target.href);
        return;
      }
      status.textContent = group.dataset.empty;
      status.hidden = false;
    } catch (error) {
      status.textContent = group.dataset.error;
      status.hidden = false;
    } finally { restore(); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bv-language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bv-language-selector')) {
    class BvLanguageSelector extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        const details = this.querySelector('details');
        const form = this.querySelector('form');
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            details.open = false;
            details.querySelector('summary').focus();
            event.stopPropagation();
          }
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) details.open = false;
        }, options);
        form.addEventListener('submit', () => {
          const target = new URL(location.href);
          target.searchParams.delete('locale');
          const input = form.querySelector('[name="return_to"]');
          if (input) input.value = target.pathname + target.search + target.hash;
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('bv-language-selector',BvLanguageSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bv-recommendation-browser"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bv-random-recommendations')) return;
  const randomIndex = length => {
    const buffer = new Uint32Array(1);
    const ceiling = Math.floor(4294967296 / length) * length;
    do { crypto.getRandomValues(buffer); } while (buffer[0] >= ceiling);
    return buffer[0] % length;
  };
  const shuffle = items => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = randomIndex(i + 1);
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  const read = async url => {
    const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Cards unavailable');
    return response;
  };
  class RandomRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.started) {
        if (this.index < 0 && !this.busy) this.observer?.observe(this);
        return;
      }
      this.started = true;
      this.pages = [];
      this.index = -1;
      this.cursor = 0;
      this.pool = null;
      this.track = this.querySelector('[data-bv-rec-track]');
      this.viewport = this.querySelector('.bv-rec-viewport');
      this.previous = this.querySelector('[data-bv-rec-prev]');
      this.next = this.querySelector('[data-bv-rec-next]');
      this.status = this.querySelector('[data-bv-rec-status]');
      this.retry = this.querySelector('[data-bv-rec-retry]');
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.retry.addEventListener('click', () => this.move(1));
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.move(1);
      }, {rootMargin:'400px'});
      this.observer.observe(this);
      this.arrangeLayout();
    }
    arrangeLayout() {
      const section = this.closest('.shopify-section');
      const media = document.querySelector('main .product-information__media');
      if (!section || !media || !media.closest('.product-information--media-left')) return;
      const home = document.createComment('bv-recommendations-home');
      section.before(home);
      const wide = window.matchMedia('(min-width: 750px)');
      const arrange = () => {
        if (!home.isConnected || !media.isConnected) {
          wide.removeEventListener('change', arrange);
          return;
        }
        media.classList.toggle('bv-media-with-recommendations', wide.matches);
        section.classList.toggle('bv-recommendations-in-media', wide.matches);
        if (wide.matches && section.parentElement !== media) media.append(section);
        if (!wide.matches && section.previousSibling !== home) home.after(section);
      };
      wide.addEventListener('change', arrange);
      arrange();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async catalogue() {
      const base = new URL(this.dataset.singlesUrl, location.origin);
      base.searchParams.set('view','bv-random');
      base.searchParams.set('filter.v.availability','1');
      base.searchParams.set('sort_by','created-ascending');
      const first = await (await read(base)).json();
      if (!Array.isArray(first.products) || !Number.isInteger(first.pages) || first.total > 25000) throw new Error('Invalid catalogue');
      const products = [...first.products];
      for (let page=2; page<=first.pages; page+=4) {
        const chunks = await Promise.all(Array.from({length:Math.min(4,first.pages-page+1)}, async (_,offset) => {
          const url = new URL(base); url.searchParams.set('page',String(page+offset));
          return (await read(url)).json();
        }));
        for (const chunk of chunks) {
          if (!Array.isArray(chunk.products)) throw new Error('Invalid catalogue page');
          products.push(...chunk.products);
        }
      }
      return shuffle([...new Map(products.filter(item => item.eligible && item.id !== this.dataset.currentId).map(item => [item.id,item])).values()]);
    }
    async card(item) {
      const url = new URL(item.url, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error('Invalid card');
      url.search = '';
      url.searchParams.set('section_id',this.dataset.sectionId);
      const response = await read(url);
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const source = doc.querySelector('template[data-bv-card-source]');
      if (!source || source.dataset.bvCardSource !== item.id) throw new Error('Card unavailable');
      if (source.dataset.eligible !== 'true') return null;
      const wrapper = document.createElement('div');
      wrapper.dataset.cardId = item.id;
      wrapper.append(source.content.cloneNode(true));
      const ids = new Map();
      wrapper.querySelectorAll('[id]').forEach(node => {const old=node.id;node.id=`bv-rec-${item.id}-${old}`;ids.set(old,node.id);});
      wrapper.querySelectorAll('*').forEach(node => {
        for (const attr of ['for','form','aria-controls','aria-labelledby','aria-describedby']) {
          if (node.hasAttribute(attr)) node.setAttribute(attr,node.getAttribute(attr).split(' ').map(id=>ids.get(id)||id).join(' '));
        }
        const href = node.getAttribute('href');
        if (href?.startsWith('#') && ids.has(href.slice(1))) node.setAttribute('href',`#${ids.get(href.slice(1))}`);
      });
      return wrapper;
    }
    async nextPage() {
      const page = document.createElement('div');
      page.className = 'bv-rec-page';
      let cursor = this.cursor;
      while (page.children.length < 4 && cursor < this.pool.length) {
        const batch = this.pool.slice(cursor,cursor + 4 - page.children.length);
        const cards = await Promise.all(batch.map(item=>this.card(item)));
        cards.filter(Boolean).forEach(card=>page.append(card));
        cursor += batch.length;
      }
      this.cursor = cursor;
      if (!page.children.length) return false;
      page.inert = true;
      page.setAttribute('aria-hidden','true');
      page.setAttribute('role','group');
      page.setAttribute('aria-label',`${this.dataset.pageLabel} ${this.pages.length+1}`);
      if (!this.pages.length) this.track.replaceChildren();
      this.track.append(page);
      this.pages.push(page);
      return true;
    }
    update() {
      this.previous.disabled = this.busy || this.index <= 0;
      this.next.disabled = this.busy || (!this.pool || (this.index >= this.pages.length-1 && this.cursor >= this.pool.length));
      this.viewport.setAttribute('aria-busy',String(Boolean(this.busy)));
    }
    async move(direction) {
      if (this.busy || (direction<0 && this.index<=0)) return;
      this.busy = true;
      this.retry.hidden = true;
      this.status.textContent = this.dataset.loading;
      this.update();
      try {
        if (!this.pool) this.pool = await this.catalogue();
        let target = this.index + direction;
        if (target >= this.pages.length) {
          if (!(await this.nextPage())) target = this.index;
        }
        if (target < 0) {
          this.track.replaceChildren();
          this.status.textContent = this.dataset.empty;
        } else {
          this.index = target;
          this.pages.forEach((page,index)=>{page.inert=index!==target;page.setAttribute('aria-hidden',String(index!==target));});
          this.track.style.transform = `translateX(-${target*100}%)`;
          this.status.textContent = `${this.dataset.pageLabel} ${target+1}`;
        }
      } catch (error) {
        this.status.textContent = this.dataset.error;
        this.retry.hidden = false;
      } finally {
        this.busy = false;
        this.update();
      }
    }
  }
  customElements.define('bv-random-recommendations',RandomRecommendations);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bv-sale-results"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bv-sale-results')) return;
  class SaleResults extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.random = new URL(location.href).searchParams.get('bv_sort') === 'random';
      this.sale = new URL(location.href).searchParams.get('bv_sale') === '1';
      this.labels = JSON.parse(this.querySelector('[data-bv-sale-labels]').textContent);
      const start = () => {
        document.querySelectorAll('sorting-filter-component').forEach(component => {
          if (!this.random) return;
          component.querySelectorAll('[role="option"]').forEach(option => {
            const input = option.querySelector('input[name="sort_by"]');
            if (!input) return;
            input.checked = input.value === 'random';
            option.setAttribute('aria-selected', String(input.checked));
            option.tabIndex = input.checked ? 0 : -1;
          });
          const status = component.querySelector('.facets__status');
          if (status) status.textContent = this.labels.random_sort;
        });
        if (this.random || this.sale) this.load();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true,signal:this.controller.signal});
      else start();
      const sort = event => {
        const component = event.target.closest('sorting-filter-component');
        if (!component) return;
        const input = event.target.closest('[name="sort_by"]') || event.target.closest('label')?.querySelector('[name="sort_by"]');
        if (!input || !input.value || input.disabled) return;
        if (event.type === 'click' && input.tagName === 'SELECT') return;
        event.preventDefault(); event.stopImmediatePropagation();
        const url = new URL(location.href);
        if (input.value === 'random') {
          url.searchParams.set('bv_sort','random');
          url.searchParams.set('sort_by',url.pathname.includes('/search') ? 'relevance' : 'manual');
        } else {
          url.searchParams.delete('bv_sort');
          url.searchParams.set('sort_by',input.value);
        }
        url.searchParams.delete('page'); url.searchParams.delete('bv_sale_page');
        if (url.href === location.href) location.reload();
        else location.assign(url);
      };
      document.addEventListener('change',sort,{capture:true,signal:this.controller.signal});
      document.addEventListener('click',sort,{capture:true,signal:this.controller.signal});
      window.addEventListener('popstate',() => {
        if (this.random !== (new URL(location.href).searchParams.get('bv_sort') === 'random') || this.sale !== (new URL(location.href).searchParams.get('bv_sale') === '1')) location.reload();
        else if(this.cards) this.render();
      },{signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
    node(tag,text,className) {
      const node = document.createElement(tag);
      if(text !== undefined) node.textContent=text;
      if(className) node.className=className;
      return node;
    }
    clearLink() {
      const url=new URL(location.href);
      (this.sale ? ['bv_sale','bv_sale_page','page'] : ['bv_sort','bv_sale_page','page']).forEach(key=>url.searchParams.delete(key));
      const link=this.node('a',this.sale ? this.labels.clear_sale : this.labels.exit_random);link.href=url;return link;
    }
    async load() {
      const target=document.querySelector('#ResultsList');
      if(!target) return;
      this.target=target;
      const source=target.querySelector('ul.product-grid');
      this.grid=source ? source.cloneNode(false) : this.node('ul',undefined,'product-grid product-grid--grid');
      this.grid.setAttribute('ref','grid');
      this.surface=this.node('div',undefined,'bv-sale-surface');
      this.surface.dataset.bvSaleSurface='';
      const sourceWrapper=source?.parentElement;
      if(sourceWrapper?.getAttribute('style')) this.surface.setAttribute('style',sourceWrapper.getAttribute('style'));
      this.status=this.node('p',this.random ? this.labels.random_loading : this.labels.sale_loading,'bv-sale-status');this.status.setAttribute('role','status');
      this.surface.append(this.status);target.append(this.surface);target.setAttribute('aria-busy','true');
      target.closest('results-list')?.setAttribute('infinite-scroll','false');
      try {
        let url=new URL(location.href);
        ['page','bv_sale_page','section_id','sections','bv_sale'].forEach(key=>url.searchParams.delete(key));
        url.searchParams.delete('bv_sort');
        url.searchParams.set('view',this.sale ? 'bv-sale-data' : 'bv-random-data');
        const cards=[];const seen=new Set();const visited=new Set();
        let expectedPage=1;
        while(url) {
          if(visited.has(url.href)||expectedPage>100) throw new Error('Incomplete sale results');
          visited.add(url.href);
          const response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.any([this.controller.signal,AbortSignal.timeout(20000)])});
          if(!response.ok) throw new Error('Sale request failed');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const marker=doc.querySelector('[data-bv-sale-meta]');
          if(!marker) throw new Error('Missing sale metadata');
          const meta=JSON.parse(marker.textContent);
          if(meta.page!==expectedPage||meta.items>25000||(!meta.next&&meta.page<meta.pages)) throw new Error('Incomplete sale pagination');
          doc.querySelectorAll('#ResultsList li[data-product-id]').forEach(card=>{
            if(!seen.has(card.dataset.productId)){seen.add(card.dataset.productId);cards.push(card);}
          });
          url=meta.next ? new URL(meta.next,url) : null;
          if(url && url.origin!==location.origin) throw new Error('Invalid pagination destination');
          if(url) url.searchParams.set('view',this.sale ? 'bv-sale-data' : 'bv-random-data');
          expectedPage++;
        }
        if(this.controller.signal.aborted||!this.isConnected) return;
        if (this.random) this.shuffle(cards);
        this.cards=cards;
        document.querySelectorAll('.products-count-wrapper').forEach(node=>{(node.querySelector('[role="status"]') || node).textContent=`${cards.length} ${(this.sale ? (cards.length===1?this.labels.sale_count_one:this.labels.sale_count) : (cards.length===1?this.labels.random_count_one:this.labels.random_count)).toLowerCase()}`;node.dataset.bvSaleCount='';});
        this.render();
      } catch(error) {
        if(this.controller.signal.aborted) return;
        this.status.textContent=this.random ? this.labels.random_error : this.labels.sale_error;
        const actions=this.node('div',undefined,'bv-sale-actions');const retry=this.node('button',this.labels.retry);retry.type='button';retry.addEventListener('click',()=>location.reload());actions.append(retry,this.clearLink());this.surface.append(actions);
      } finally { target.removeAttribute('aria-busy'); }
    }
    shuffle(cards) {
      const keyUrl = new URL(location.href);
      ['page','bv_sale_page','preview_theme_id'].forEach(key => keyUrl.searchParams.delete(key));
      keyUrl.searchParams.sort();
      const key = 'bv-last-shuffle:' + keyUrl.pathname + keyUrl.search;
      let previous = '';
      try { previous = sessionStorage.getItem(key) || ''; } catch (error) {}
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      const signature = () => cards.map(card => card.dataset.productId).join(',');
      if (cards.length > 1 && signature() === previous) {
        const j = 1 + Math.floor(Math.random() * (cards.length - 1));
        [cards[0], cards[j]] = [cards[j], cards[0]];
      }
      try { sessionStorage.setItem(key, signature()); } catch (error) {}
      const url = new URL(location.href);
      url.searchParams.delete('bv_sale_page');
      history.replaceState(history.state,'',url);
    }
    render() {
      const pageSize=24,total=Math.max(1,Math.ceil(this.cards.length/pageSize));
      let page=Number(new URL(location.href).searchParams.get('bv_sale_page'))||1;
      page=Math.max(1,Math.min(total,Math.floor(page)));
      this.surface.replaceChildren();
      this.grid.replaceChildren();
      this.cards.slice((page-1)*pageSize,page*pageSize).forEach((card,index)=>{
        const item=document.importNode(card,true);item.dataset.page='1';item.className=item.className.replace(/product-grid__item--\d+/g,`product-grid__item--${index}`);this.grid.append(item);
      });
      if(this.cards.length) this.surface.append(this.grid);
      else {const empty=this.node('p',this.random ? this.labels.random_empty : this.labels.sale_empty,'bv-sale-status');empty.setAttribute('role','status');this.surface.append(empty);}
      const actions=this.node('div',undefined,'bv-sale-actions');
      if(total>1) {
        const change=next=>{const url=new URL(location.href);url.searchParams.set('bv_sale_page',String(next));history.pushState(null,'',url);this.render();this.target.scrollIntoView({block:'start'});};
        const prev=this.node('button',this.labels.previous);prev.type='button';prev.disabled=page===1;prev.addEventListener('click',()=>change(page-1));
        const next=this.node('button',this.labels.next);next.type='button';next.disabled=page===total;next.addEventListener('click',()=>change(page+1));
        actions.append(prev,this.node('span',`${this.labels.page} ${page} / ${total}`),next);
      }
      actions.append(this.clearLink());this.surface.append(actions);
      [...this.target.children].filter(node=>node!==this.surface).forEach(node=>node.remove());
    }
  }
  customElements.define('bv-sale-results',SaleResults);
})();
  } catch(e) { console.error(e); }
})();

})();
